import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5330d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "great-events" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title event-title" }, "公司大事记", -1))
const _hoisted_3 = {
  key: 0,
  class: "timeline-event-odd"
}
const _hoisted_4 = {
  key: 0,
  class: "timeline-event-box-item"
}
const _hoisted_5 = { class: "timeline-event-title" }
const _hoisted_6 = { class: "event-year" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-event-box-line" }, null, -1))
const _hoisted_8 = {
  key: 1,
  class: "timeline-event-even"
}
const _hoisted_9 = {
  key: 0,
  class: "timeline-event-odd-item"
}
const _hoisted_10 = { class: "timeline-event-title" }
const _hoisted_11 = { class: "event-year" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-event-box-line" }, null, -1))

import { ref, reactive, onMounted, onUnmounted, onBeforeUnmount } from "vue";
import { listEvent } from "@/api/product";

// 大事记
// const eventsList = ref([]); // 大事记表格数据     直接这么写，ts会报错！！！
// 初始值是空数组，ts可以通过推断确定这个数组的类型是 IEventRes[]，因此这个写法是有效的！

export default /*#__PURE__*/_defineComponent({
  __name: 'greatEvents',
  setup(__props) {

const eventsList = ref<IEventRes[]>([]);
const total = ref<number>(0);
// const years = ref([]); // 完整的年份数组
// 在初始化时，明确指定初始值类型为string[]。这样后续将字符串数组赋值给years.value，避免出现报错了。
const years = ref<string[]>([]);

//查询参数
const queryParams = reactive<IEventQuery>({
  pageNum: 1,
  pageSize: 50,
});

// 查询大事记列表
function getList() {
  // 调用获取列表的接口
  listEvent(queryParams).then((response: IResponseData<IEventRes>) => {
    eventsList.value = response.rows; // 后端获取的数据赋值给新闻列表
    total.value = response.total;

    // 拿到每条数据中的年份，放在新的数组中，并用Set去重
    const yearsArr = [
      ...new Set(eventsList.value.map((event) => event.eventYear)),
    ];
    // 将 字符串数组  转换为  数字数组
    const yearsArrNumbers = yearsArr.map(Number);
    years.value = yearsArrNumbers.map(String);

    // // 拿到最大、最小的年份；补全年份数组中间缺失的年份
    // const minYear = Math.min(...yearsArrNumbers);
    // const maxYear = Math.max(...yearsArrNumbers);
    // const fullYearsArr = [];
    // // 使用一个循环，从最早的年份开始，逐年检查是否在年份数组中。如果年份不在年份数组中，则将其转换为字符串并添加到 fullYearsArr 数组中。
    // for (let year = minYear; year <= maxYear; year++) {
    //   fullYearsArr.push(year.toString());
    // }
    // // 将去重后的年份数组赋值给 years
    // years.value = fullYearsArr;
  });
}

getList(); // 页面加载调用getList方法

// 实现大事记可拖动,拖动时间轴容器可以拖动
const timelineContainer = ref<HTMLElement | null>(null);
const timeline = ref<HTMLElement | null>(null);
const isDragging = ref(false); // ，用来表示用户是否正在拖动时间轴
const startX = ref(0); // 存储用户开始拖动时的鼠标位置
const startTranslateX = ref(0); // 时间轴的初始偏移量

// 实现网页端区域可拖动 🥗🥗🍇🍋‍🟩🍆🍅🥑
// // 当用户按下鼠标时（mousedown事件），记录鼠标的初始位置和时间轴的当前偏移量
// const startDrag = (event: MouseEvent) => {
//   // 拖动时间轴容器
//   isDragging.value = true; // 开始拖拽
//   startX.value = event.clientX;
//   // 获取时间轴当前的偏移量
//   const rect = timeline.value!.getBoundingClientRect();
//   startTranslateX.value =
//     rect.left - timelineContainer.value!.getBoundingClientRect().left;
//   // 检查鼠标事件的目标是否是时间轴或其子元素(拖动时间轴段才能拖动)
//   // if (
//   //   timeline.value &&
//   //   (event.target === timeline.value ||
//   //     timeline.value.contains(event.target as Node))
//   // ) {
//   //   isDragging.value = true;
//   //   startX.value = event.clientX;
//   //   const rect = timeline.value!.getBoundingClientRect();
//   //   startTranslateX.value =
//   //     rect.left - timelineContainer.value!.getBoundingClientRect().left;
//   // }
// };

// // 当用户移动鼠标时（mousemove事件），如果处于拖动状态，计算新的偏移量并更新时间轴的位置
// // 这个函数会计算鼠标的移动量 (deltaX)，并更新时间轴的位置。新的位置是通过将初始偏移量 (startTranslateX) 加上鼠标移动量来得到的，并应用到时间轴的 transform 属性上。
// const onDrag = (event: MouseEvent) => {
//   if (isDragging.value) {
//     const deltaX = event.clientX - startX.value;
//     const newTranslateX = startTranslateX.value + deltaX;
//     // 更新时间轴的位置
//     timeline.value!.style.transform = `translateX(${newTranslateX}px)`;
//   }
// };

// 实现网页端和移动端都可以区域可拖动 😎😎😎😎😎😎
// 获取事件的X坐标，无论是鼠标事件还是触摸事件
const getEventClientX = (event: MouseEvent | TouchEvent): number => {
  if (event instanceof MouseEvent) {
    return event.clientX;
  } else {
    return event.touches[0].clientX;
  }
};

// 当用户按下鼠标或触摸屏幕时，记录初始位置和时间轴的当前偏移量
const startDrag = (event: MouseEvent | TouchEvent) => {
  isDragging.value = true; // 开始拖拽
  startX.value = getEventClientX(event);
  // 获取时间轴当前的偏移量
  const rect = timeline.value!.getBoundingClientRect();
  startTranslateX.value =
    rect.left - timelineContainer.value!.getBoundingClientRect().left;

  // 阻止默认行为，防止页面滚动
  if (event instanceof TouchEvent) {
    event.preventDefault();
  }
};

// 当用户移动鼠标或手指时，计算新的偏移量并更新时间轴的位置
const onDrag = (event: MouseEvent | TouchEvent) => {
  if (isDragging.value) {
    const deltaX = getEventClientX(event) - startX.value;
    const newTranslateX = startTranslateX.value + deltaX;
    // 更新时间轴的位置
    timeline.value!.style.transform = `translateX(${newTranslateX}px)`;

    // 阻止默认行为，防止页面滚动
    if (event instanceof TouchEvent) {
      event.preventDefault();
    }
  }
};

// 当用户释放鼠标或鼠标离开时间轴容器时（mouseup或mouseleave事件），停止拖动
const endDrag = () => {
  isDragging.value = false;
};

// 🐸🐸🐸🐸🐸🐸🐸🐸    定义适配函数
const reScreenSize = () => {
  let w = document.documentElement.clientWidth;
  let newFontSize = 10 * (w / 1920);
  newFontSize = Math.max(7.4, Math.min(newFontSize, 40));
  document.documentElement.style.fontSize = `${newFontSize}px`;
};

// 页面加载时执行一次适配
onMounted(() => {
  reScreenSize();
  window.addEventListener("resize", reScreenSize);
});

// 页面卸载时移除监听事件
onUnmounted(() => {
  window.removeEventListener("resize", reScreenSize);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "timeline-container",
      ref_key: "timelineContainer",
      ref: timelineContainer,
      onMousedown: startDrag,
      onMousemove: onDrag,
      onMouseup: endDrag,
      onMouseleave: endDrag,
      onTouchstart: startDrag,
      onTouchmove: onDrag,
      onTouchend: endDrag
    }, [
      _createElementVNode("div", {
        class: "timeline",
        ref_key: "timeline",
        ref: timeline
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(years.value, (year, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: year,
            class: _normalizeClass([
            'timeline-year',
            {
              'timeline-year-odd': index % 2 === 0 && index !== 0, // index为偶数的时间段（排除第一个时间段）
              'timeline-year-even':
                index % 2 !== 0 && index !== years.value.length - 1, // index为奇数的时间段(排除最后一个时间段)
              'timeline-year-first': index === 0, // 第一个时间段，即：数组的第一个元素（index = 0）
              'timeline-year-last': index === years.value.length - 1, // 最后一个时间段，即：数组的最后一个元素
            },
          ])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({ 'triangle-up': index % 2 !== 0 })
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass({ 'triangle-down': index % 2 === 0 })
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(
              index % 2 === 0
                ? 'timeline-year-label-even'
                : 'timeline-year-label-odd'
            )
            }, _toDisplayString(year), 3),
            (index % 2 !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventsList.value, (event) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (event.eventYear == year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("p", _hoisted_6, _toDisplayString(event.eventYearMonth), 1),
                              _createElementVNode("p", null, _toDisplayString(event.eventContent), 1)
                            ]),
                            _hoisted_7
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventsList.value, (event) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: event.eventId
                    }, [
                      (event.eventYear === year)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("p", _hoisted_11, _toDisplayString(event.eventYearMonth), 1),
                              _createElementVNode("p", null, _toDisplayString(event.eventContent), 1)
                            ]),
                            _hoisted_12
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 128))
                ]))
          ], 2))
        }), 128))
      ], 512)
    ], 544)
  ]))
}
}

})